import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncPrivacy = lazy(() => import('~/containers/PrivacyPolicy'));

export default [
  <Route path="/privacy">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncPrivacy />
    </Suspense>
  </Route>,
];
